import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { I18nModule, provideDefaultConfig } from "@spartacus/core";
import { GenericLinkModule, IconModule } from "@spartacus/storefront";
import { KbNavigationUiComponent } from "./kb-navigation-ui.component";
import { RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    IconModule,
    GenericLinkModule,
    I18nModule,
  ],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        NavigationUIComponent: {
          component: KbNavigationUiComponent,
        },
      },
    }),
  ],
  exports: [KbNavigationUiComponent],
  declarations: [KbNavigationUiComponent]
})
export class KbNavigationUiModule {

}
